import { html } from 'lit';
const Heartbreak =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M12 4.924c-2.048-1.87-5.144-2.367-7.547-.32-2.557 2.178-2.927 5.843-.907 8.434.777.997 2.302 2.503 3.776 3.89a166 166 0 0 0 3.706 3.371l.013.012c.07.061.152.134.23.191.09.069.215.15.38.198.223.067.463.067.685 0 .165-.049.29-.13.381-.198.078-.057.16-.13.23-.191l.012-.012c.733-.647 2.218-1.97 3.707-3.371 1.474-1.387 2.998-2.893 3.775-3.89 2.014-2.583 1.7-6.275-.914-8.44-2.433-2.016-5.484-1.545-7.527.326m1.053 1.068L14.53 7.47a.75.75 0 0 1-.195 1.2l-3.069 1.536 2.264 2.264a.75.75 0 0 1-1.06 1.06l-3-3a.75.75 0 0 1 .195-1.2l3.069-1.535L11.47 6.53l-.04-.042c-1.593-1.857-4.134-2.335-6.004-.742-1.953 1.663-2.217 4.42-.697 6.37.695.891 2.134 2.321 3.62 3.72a165 165 0 0 0 3.645 3.314c.736-.65 2.19-1.947 3.644-3.314 1.486-1.399 2.926-2.829 3.62-3.72 1.528-1.96 1.285-4.728-.688-6.363-1.732-1.435-3.936-1.188-5.517.239" clip-rule="evenodd"/>
  </svg>
`;
export default Heartbreak;
